import React, { useEffect } from 'react'
import { ButtonType } from '../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useAppDispatch } from '../../../store'
import { grey } from '../../../colors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../components/GenericModal/DefaultModalActions'
import { deleteDivisionCoursesApi } from '../../../store/slices/courseCatalogSlice/api'
import { type IDivisionRow } from '../../../models/Division'
import { actionLoading } from '../../../store/slices/courseCatalogSlice/selectors'
import { type ApiError } from '../../../models/Common'
import { notifyError } from '../../../utils/notifyError'

interface DeleteCourseCatalogProps {
  selectedRow?: IDivisionRow
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
  isTaskRunning?: boolean
  onTaskBlock?: () => void
}

const DeleteCourseCatalog: React.FC<DeleteCourseCatalogProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage, isTaskRunning, onTaskBlock }) => {
  const dispatch = useAppDispatch()
  const loading = actionLoading()
  const theme = useTheme()

  useEffect(() => {
    if (selectedRow != null && isTaskRunning) {
      onTaskBlock?.()
      handleCloseModal?.()
    }
  }, [selectedRow])

  const handleDelete = async (): Promise<void> => {
    try {
      await dispatch(deleteDivisionCoursesApi({ urlId: selectedRow?.divisionId })).unwrap().then(() => { handleCloseModal?.() })
    } catch (error) {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message)
        showErrorModal?.()
        return
      }
      notifyError(error)
    }
  }
  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
      You will not be able to recover this Course. All references to it will be deleted.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteCourseCatalog
